export type ManualDurationUnit = 'MONTH' | 'DAY' | 'HOUR';

/** Keep the selected unit so the API can distinguish short-term quota extensions. */
export function manualDurationPayload(unit: ManualDurationUnit, count: number) {
  const durationCount = count * (unit === 'MONTH' ? 2678400 : unit === 'DAY' ? 86400 : 3600);
  if (!Number.isSafeInteger(durationCount) || durationCount < 1 || durationCount > 4294967295) throw new Error('換算後的期間超過可發放範圍');
  return { durationUnit: unit === 'MONTH' ? 'FIXED_MONTH' as const : unit, durationCount: count };
}

export function durationText(value: string | null | undefined) {
  if (value == null) return '尚無法確認';
  const seconds = BigInt(value);
  const remainder = seconds % 3600n;
  return `${seconds / 86400n} 天 ${seconds % 86400n / 3600n} 小時${remainder ? ` ${remainder / 60n} 分 ${remainder % 60n} 秒` : ''}`;
}
